<template>
  <move-template :automatic="automatic" :order-type="queryParam.value.business.orderType" :type="type" />
</template>

<script>
  import MoveTemplate from '@/views/warehouse_management/movebound/MoveTemplate.vue'

  export default {
    name: 'AutomaticMoveOrder',
    components: { MoveTemplate },
    props: {
      queryParam: {
        type: Object,
        default: null
      }
    },
    data() {
      return {
        type: 'movementTransfer',
        automatic: true
      }
    },
    methods: {}
  }
</script>